import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex lg:items-center md:items-center items-start justify-between mb-1" }
const _hoisted_3 = { class: "font-bold lg:mr-0 md:mr-0 mr-2 break-all lg:w-auto md:w-auto w-auto flex-1 noresi" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex items-center lg:w-auto md:w-auto w-auto cursor-pointer" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "26",
    height: "30",
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M12.9771 0C17.5802 0 21.2841 3.62218 21.2841 8.09401V10.394C23.8676 11.2004 25.75 13.5392 25.75 16.3326V23.7379C25.75 27.1962 22.883 30 19.3483 30H6.6532C3.11703 30 0.25 27.1962 0.25 23.7379V16.3326C0.25 13.5392 2.13392 11.2004 4.71593 10.394V8.09401C4.73117 3.62218 8.435 0 12.9771 0ZM12.9924 17.0764C12.2608 17.0764 11.6663 17.6578 11.6663 18.3732V21.6824C11.6663 22.4128 12.2608 22.9941 12.9924 22.9941C13.7392 22.9941 14.3337 22.4128 14.3337 21.6824V18.3732C14.3337 17.6578 13.7392 17.0764 12.9924 17.0764ZM13.0076 2.60857C9.91348 2.60857 7.39854 5.05317 7.38329 8.0642V10.0706H18.6167V8.09401C18.6167 5.06807 16.1018 2.60857 13.0076 2.60857Z",
      fill: "#90A4AE"
    })
  ])
], -1)
const _hoisted_5 = { class: "flex items-center justify-between mb-2" }
const _hoisted_6 = { class: "detail-route flex items-center" }
const _hoisted_7 = { class: " px-2 rounded-md lg:text-sm md:text-sm text-xs" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between pt-2" }
const _hoisted_9 = { class: "flex md:flex-row flex-col lg:items-center md:items-center items-start lg:w-2/3 md:w-2/3 w-full md:divide-x md:divide-green-500" }
const _hoisted_10 = { class: "flex sm:w-full md:w-auto md:mr-2" }
const _hoisted_11 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_12 = {
  class: "px-2 inline-block rounded-md font-semibold text-base color-green-darken-1",
  style: {"background-color":"#E8F5E9","color":"rgb(84, 110, 122)","border":"1px solid rgb(67, 160, 71)"}
}
const _hoisted_13 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_14 = {
  class: "px-2 inline-block rounded-md font-semibold text-base",
  style: {"background-color":"rgb(236, 239, 241)","color":"rgb(84, 110, 122)","border":"1px solid rgb(84, 110, 122)"}
}
const _hoisted_15 = { class: "flex md:flex-row lg:flex-row flex-row-reverse  md:justify-start justify-between sm:w-full md:w-auto md:divide-x md:divide-green-500" }
const _hoisted_16 = {
  key: 0,
  class: " flex lg:w-auto px-2"
}
const _hoisted_17 = { class: "font-semibold color-green-darken-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "pl-2" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-check-circle color-green-darken-1" })
], -1)
const _hoisted_19 = { class: "lg:flex md:flex  cursor-pointer my-2 lg:my-1" }
const _hoisted_20 = { class: "color-green-darken-3 font-semibold " }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Penutup : ")
const _hoisted_22 = { class: "font-bold text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Card, {
          class: `cursor-pointer card-no-shadow mt-2 card-item-category `,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail(_ctx.item.Id))),
          style: {"background":"#ECEFF1"}
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.item.KodeJadwal), 1),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.item.TanggalAktif).format('DD MMMM YYYY')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", _hoisted_12, _toDisplayString(_ctx.item.Rit?`Rit ${_ctx.item.Rit}`:''), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", _hoisted_14, _toDisplayString(_ctx.item.Kode), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  (_ctx.item.IsClose === true)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, "Dicek : " + _toDisplayString(_ctx.item.DoneScan) + "/" + _toDisplayString(_ctx.item.NotDoneScan+_ctx.item.DoneScan), 1),
                        _hoisted_18
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("p", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.item.NamaLengkap), 1),
                  _createTextVNode(" (" + _toDisplayString(_ctx.moment(_ctx.item.CloseDate).format('DD MM YYYY, HH:mm')) + " WIB) ", 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}